import type { ApiResponse } from '@/shared/types';
import api from '@/shared/api/client';
import { parseContentDispositionFileName } from '@/shared/pdf/blobActions';

export type ReportDemoPdfResult = {
  blob: Blob;
  fileName: string;
};

export const operatorReportApi = {
  listReportLogs: (params?: Record<string, any>) =>
    api.get<ApiResponse<any>>('/operator/report-logs', { params }),

  getReportLog: (id: string) =>
    api.get<ApiResponse<any>>(`/operator/report-logs/${id}`),

  reprintReportFromLog: async (id: string): Promise<ReportDemoPdfResult> => {
    const response = await api.post<Blob>(`/operator/report-logs/${id}/reprint`, undefined, {
      responseType: 'blob',
      skipProgressBar: true,
    } as any);

    return {
      blob: response.data,
      fileName:
        parseContentDispositionFileName(response.headers['content-disposition']) ||
        `report-log-${id}.pdf`,
    };
  },

  printDemoReport: async (locale?: string): Promise<ReportDemoPdfResult> => {
    const response = await api.post<Blob>('/operator/reports/demo', { locale }, {
      responseType: 'blob',
      skipProgressBar: true,
    } as any);

    return {
      blob: response.data,
      fileName:
        parseContentDispositionFileName(response.headers['content-disposition']) ||
        'report-demo.pdf',
    };
  },
};
